import { Translation, QRType } from '../types';

export const zhCn: Translation = {
  nav: {
    generator: '生成器',
    scanner: '扫描器',
    mobile: '手机体验',
    blog: '博客',
    langSelect: '选择语言',
  },
  pageTitles: {
    generator: '免费在线二维码生成器',
    scanner: '在线二维码扫描器',
    textToQr: '文本转二维码',
    linkToQr: '链接转二维码',
  },
  pageMeta: {
    generator: {
      title: '免费二维码生成器 — 在线创建二维码（无注册、无水印、PNG/SVG/PDF）| YesQRCode',
      description:
        '使用 YesQRCode 免费在线创建二维码。支持网址、文本、WiFi、名片等，下载高质量 PNG、SVG 或 PDF。无需账号，无水印，快速、安全，永久免费。',
      keywords: ['二维码生成器', '免费二维码', '在线制作二维码', '二维码PNG', '二维码SVG', '二维码PDF', 'WiFi二维码', '名片二维码', '无需注册二维码', 'Logo二维码'],
    },
    scanner: {
      title: '在线二维码扫描器 — 图片/摄像头扫码（安全、无需注册）| YesQRCode',
      description:
        '免费在线扫描二维码和条形码。上传图片或直接用摄像头。本地解码，不上传文件。安全、快速、无需注册，完全免费。',
      keywords: ['二维码扫描', '在线扫码', '网页扫码', '图片扫码', '在线扫条码', '安全扫码', '离线扫码', '免费二维码扫描器', '浏览器扫码', '无需注册扫码'],
    },
    textToQr: {
      title: '文本转二维码 | 将笔记即时生成可分享的二维码',
      description: '把文本、留言或提示一键生成可分享的二维码。自定义品牌样式，立即下载 PNG、SVG 或 PDF，无需注册。',
      keywords: ['文本转二维码', '文字二维码生成', '留言二维码', '笔记二维码', '在线文本二维码', '免费文字二维码'],
    },
    linkToQr: {
      title: '链接转二维码 | 将网址快速生成二维码',
      description: '粘贴任意网址，立即生成可打印或数字使用的品牌化二维码。支持自定义颜色、Logo、高分辨率下载。',
      keywords: ['链接转二维码', '网址二维码', '网站二维码', 'UTM 二维码', '二维码下载PDF', '在线生成网址二维码'],
    },
  },
  hero: {
    title: '创建私密、品牌就绪的二维码 —— 永久免费。',
    subtitle: '快速、注重隐私且灵活的二维码工具，适配任何工作流。',
    desc: '无需账号、无水印、无数据上传，即可生成和扫描高品质二维码。',
    ctaPrimary: '生成二维码',
    ctaSecondary: '手机体验',
  },
  info: {
    helpTitle: '帮助中心',
    helpSubtitle: '常见问题与支持',
    contactTitle: '联系我们',
    contactSubtitle: '期待你的来信。',
    privacyTitle: '隐私政策',
    termsTitle: '服务条款',
  },
  contactForm: {
    name: '姓名',
    email: '邮箱',
    message: '留言',
    send: '发送',
    orEmail: '或直接发送邮件至',
    sending: '发送中...',
    successTitle: '已发送！',
    successMessage: '感谢你的留言，我们会尽快回复。',
    sendAnother: '再发一条',
    errorMessage: '暂时无法发送，请邮件联系 support@yesqrcode.com。',
  },
  generator: {
    highlights: {
      title: '创建私密、品牌就绪的二维码 —— 永久免费。',
      subtitle: '快速、注重隐私且灵活的二维码工具，适配任何工作流。',
      items: [
        { title: '隐私优先，本地生成', desc: '二维码在设备本地生成 —— 无上传、无追踪、无存储。' },
        { title: '覆盖所有场景', desc: '网址、WiFi、名片、条形码、Logo、渐变、相框等全都内置。' },
        { title: '移动体验友好', desc: '为手机和触控优化，创建与扫码都流畅。' },
        { title: '永久免费，可商用', desc: '无需账号、无水印、无限扫码 —— 可靠适配团队与品牌。' },
      ],
    },
    featureSuite: {
      title: '面向隐私的完整二维码套件',
      subtitle: '在同一处创建干净、品牌化且高质量的二维码。',
      categories: [
        { title: '完整类型支持', body: 'URL、文本、WiFi、邮件、电话、SMS、vCard、社交链接、YouTube、条形码。静态码永不过期。', items: [] },
        { title: '品牌设计', body: 'Logo 友好、渐变、相框、形状、圆角，兼顾美观与可扫性。', items: [] },
        { title: '输出与质量', body: '高分辨率 PNG、SVG、PDF，支持印刷与数字场景的预设。', items: [] },
        { title: '全球与易用性', body: '多语言界面，移动优先，兼容离线流程。', items: [] },
      ],
    },
    trust: {
      title: '创作者与品牌都在使用',
      subtitle: '轻量、可预期、无账号、无锁定，适合长期活动与安全场景。',
      items: ['零上手成本', '静态码稳定可用', '企业安全：无云端处理', '跨素材保持一致品牌'],
    },
    sectionContent: '内容',
    sectionColors: '颜色',
    sectionLogo: 'Logo',
    sectionFrame: '边框',
    sectionDesign: '样式',
    sectionCorrection: '容错率',
    labelUrl: '网站链接',
    labelText: '纯文本',
    labelSsid: '网络名称（SSID）',
    labelPassword: '密码',
    labelEncryption: '加密方式',
    labelFgColor: '前景色',
    labelBgColor: '背景色',
    labelFrameText: '边框文字',
    labelFrameColor: '边框颜色',
    placeholder: '在此输入内容...',
    placeholders: {
      url: 'https://example.com',
      text: '请输入文本',
      email: 'your@email.com',
      subject: '主题',
      message: '你的留言...',
      phone: '+86 138 0000 0000',
      ssid: 'MyWiFi',
      password: '***',
      barcode: '123456789012',
    },
    download: '下载 PNG',
    downloadSvg: '下载 SVG',
    generateButton: '生成二维码',
    copy: '复制 SVG',
    uploadLogo: '上传图片',
    preview: '预览',
    lowQuality: '低质量',
    highQuality: '高质量',
    foreverFree: '永久免费 • 无需注册 • 可商用',
    barcodeWarning: '条形码不支持相框和 Logo 等高级样式。',
    barcodeColors: '你仍可在下方自定义颜色。',
    frameStyles: {
      none: '无',
      simple: '简洁',
      balloon: '气泡',
      box: '方框',
      badge: '徽章',
      polaroid: '拍立得',
      phone: '手机框',
      header: '抬头',
      corner: '圆角',
    },
    vCard: {
      firstName: '名',
      lastName: '姓',
      mobile: '手机',
      phone: '电话',
      fax: '传真',
      email: '邮箱',
      company: '公司',
      job: '职位',
      street: '街道',
      city: '城市',
      zip: '邮编',
      state: '省/州',
      country: '国家',
      website: '网站',
    },
    types: {
      [QRType.URL]: '网址',
      [QRType.TEXT]: '文本',
      [QRType.EMAIL]: '邮件',
      [QRType.PHONE]: '电话',
      [QRType.SMS]: '短信',
      [QRType.WIFI]: 'WiFi',
      [QRType.VCARD]: '名片',
      [QRType.FACEBOOK]: 'Facebook',
      [QRType.TWITTER]: 'X (Twitter)',
      [QRType.YOUTUBE]: 'YouTube',
      [QRType.BARCODE]: '条形码',
    },
    guide: {
      title: '如何创建自定义二维码？',
      steps: [],
    },
    gettingStarted: {
      title: '使用步骤',
      steps: [
        {
          title: '设置二维码内容',
          text: '选择内容类型（URL、文本、邮件等），填写扫码后要展示的信息。打印后内容无法修改，请确保准确。',
        },
        {
          title: '自定义设计',
          text: '想要独特外观？设置品牌色，调整角点和主体形状，添加 Logo 或选择渐变和边框。',
        },
        {
          title: '生成二维码',
          text: '用滑块调整像素分辨率，点击“下载”保存。打印前先用扫码器测试预览确保可读。',
        },
        {
          title: '下载图片',
          text: '可下载 .png、.svg 或 .pdf。需要矢量格式请选择 .svg；Logo 和设计当前支持 .png 和 .svg。',
        },
      ],
    },
    about: {
      title: '免费且隐私优先的二维码套件',
      subtitle: '无需账号、无水印、无数据上传即可生成/扫描高品质二维码，适合印刷、品牌和商用场景。',
      features: ['热门类型全覆盖：URL、文本、WiFi、名片、短信、条形码', '高达 30% 容错率，Logo 安全', '自定义形状、渐变、颜色、边框', '静态二维码永久有效', '多语言界面，全球团队适用'],
      content: [
        { title: 'Logo 友好的二维码', body: '添加 Logo 仍可保障扫码成功，高达 30% 容错率，适合包装、菜单、指示牌。' },
        { title: '可调形状与边框', body: '替换角点形状、应用渐变，选择适合活动的边框；设计与可扫性兼得。' },
        { title: '多种内容类型', body: '同一界面生成 URL、文本、WiFi、名片、短信、条形码，并提供对应的快捷模板。' },
        { title: '静态码长期可用', body: '创建永不过期的静态二维码，长周期活动和印刷物料都放心。' },
      ],
    },
    faq: {
      title: '常见问题',
      items: [
        { q: '什么是二维码？', a: 'QR 是 Quick Response 的缩写，由日本电装在 1994 年发明的一种二维条码。' },
        { q: '生成的二维码可以商用吗？', a: '可以，使用此生成器创建的二维码免费且可自由使用。' },
        { q: '二维码会过期吗？', a: '不会。YesQRCode 生成的二维码是静态码，不会失效，但内容生成后无法修改。' },
        { q: '扫码次数有限制吗？', a: '没有限制，可以无限次扫码。' },
        { q: 'YesQRCode 会保存我的数据吗？', a: '不会。我们不保存或重复使用你的数据。为性能考虑，二维码图片会在服务器缓存 24 小时。' },
        { q: '为什么名片二维码字段不完整？', a: '部分扫码应用未遵循 vCard 标准，可能导致字段错位，换用其他扫码器试试。' },
        {
          q: '二维码无法扫码怎么办？',
          a: '先检查输入内容是否有拼写错误。部分类型（如名片）数据量大，可适当减少。尝试移除 Logo，并保证前景与背景对比够强，前景应更深色。',
        },
        { q: 'YesQRCode 支持哪些浏览器？', a: '需要支持 HTML5 的现代浏览器，官方兼容 Chrome、Firefox、Safari、Edge 及 IE11。' },
      ],
    },
  },
  scanner: {
    title: '扫描二维码和条形码',
    subtitle: '使用摄像头、上传图片或粘贴截图，立即解码。',
    cameraPermission: '摄像头权限被拒绝，请在浏览器设置中开启。',
    result: '结果',
    copy: '复制',
    copied: '已复制',
    open: '打开链接',
    delete: '删除',
    scanAgain: '再扫一个',
    privacy: '全部在浏览器本地处理，文件不离开你的设备。',
    upload: '上传图片',
    paste: '粘贴 (Ctrl+V)',
    drop: '拖拽图片到此',
    retry: '重试',
    errorAccessDenied: '摄像头权限被拒绝',
    errorCamera: '请在浏览器设置中允许摄像头访问。',
    initializing: '正在初始化摄像头...',
    cameraActive: '摄像头已开启',
    scannedItems: '已扫描内容',
    recentScans: '最近记录（仅本地）',
    clickToUpload: '点击上传',
    newBadge: '新',
    tabCameraMobile: '摄像头',
    tabCameraDesktop: '摄像头扫描',
    emptyState: {
      title: '暂无记录',
      desc: '上传图片或切换到摄像头开始扫码。',
    },
    highlights: {
      title: '快速且私密的扫码体验',
      items: [
        { title: '本地解码', desc: '默认不上传，适合敏感链接与素材。' },
        { title: '多格式支持', desc: '支持 QR、UPC/EAN、Code 128、ITF 等。' },
        { title: '快捷操作', desc: '拖拽、粘贴或立即切换摄像头。' },
        { title: '移动端友好', desc: '为手机 UI 与摄像头流程优化。' },
      ],
    },
    intro: {
      title: '在线二维码/条形码扫描器',
      body: '在浏览器中直接解码二维码、UPC、EAN 等，无需安装应用。',
    },
    howTo: {
      title: '如何扫描？',
      methods: [
        { title: '方式一：上传', steps: ['点击“上传图片”', '选择二维码/条形码', '立即获得结果'] },
        { title: '方式二：摄像头', steps: ['打开“摄像头”标签', '授予权限', '对准二维码/条形码'] },
      ],
    },
    features: {
      title: '为什么选择这里？',
      items: [
        { title: '本地历史', desc: '最近扫描仅保存在本地，可随时复制或再次打开。' },
        { title: '离线图片解码', desc: '上传或粘贴图片即使掉线也能解码；摄像头需浏览器支持。' },
        { title: '快捷操作', desc: '复制、打开或删除结果一键完成。' },
      ],
    },
    useCases: {
      title: '常见用途',
      items: [
        { title: '零售/购物', desc: '查看商品链接、优惠券或说明。' },
        { title: '仓储团队', desc: '核对条码、处理库存更新。' },
        { title: '日常用户', desc: '快速打开菜单、Wi-Fi 链接或联系人。' },
      ],
    },
    faq: {
      title: '扫码常见问题',
      items: [
        { q: '可以扫条形码吗？', a: '可以，支持 QR 以及 Code 128、UPC、EAN、ITF 等。' },
        { q: '会保存我的扫描记录吗？', a: '不会，所有数据留在你的浏览器本地。' },
        { q: '可以粘贴截图吗？', a: '可以，按 Ctrl+V（或 Cmd+V）直接粘贴。' },
        { q: '离线可用吗？', a: '上传/粘贴图片可离线解码；摄像头扫描需要权限和受支持的浏览器。' },
      ],
    },
  },
  blog: {
    title: '洞察与指南',
    subtitle: '关于二维码体验的最佳实践、营销点子与产品更新。',
    readMore: '阅读全文',
    back: '返回博客',
    notFound: '未找到文章',
  },
  common: {
    footer: '为市场人、设计师和团队打造的强大二维码工具套件。',
    privacy: '隐私',
    terms: '条款',
    contact: '联系',
    scanToOpen: '扫码在手机打开',
    help: '帮助',
    free: '免费',
    product: '产品',
    resources: '资源',
    company: '公司',
    api: 'API（即将推出）',
    systemStatus: '系统正常',
    footerDesc: '先进的二维码生成与扫描器。快速、注重隐私，个人与商用永久免费。',
  },
};
